<template>
    <div v-if="loading" class="loading-placeholder">
        <!-- Placeholder for Stat Boxes -->
        <div v-if="subheader" class="grid mb-6">
            <div class="animate-pulse bg-slate-100 h-20 w-full"></div>
        </div>
        
        <div v-if="stats" class="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
            <div class="animate-pulse bg-slate-100 h-24 w-full"></div>
            <div class="animate-pulse bg-slate-100 h-24 w-full"></div>
            <div class="animate-pulse bg-slate-100 h-24 w-full"></div>
            <div class="animate-pulse bg-slate-100 h-24 w-full"></div>
        </div>

        <!-- Placeholder for Charts -->
        <div v-if="charts" class="grid grid-cols-1 lg:grid-cols-2 gap-x-5 mb-6">
            <div class="animate-pulse bg-slate-100 h-64 w-full"></div>
            <div class="animate-pulse bg-slate-100 h-64 w-full"></div>
        </div>

        <!-- Placeholder for Table -->
         <div v-if="table">
            <div class="animate-pulse bg-slate-100 h-12 w-full mb-2"></div>
            <div class="animate-pulse bg-slate-100 h-12 w-full mb-2"></div>
            <div class="animate-pulse bg-slate-100 h-12 w-full mb-2"></div>
            <div class="animate-pulse bg-slate-100 h-12 w-full mb-2"></div>
            <div class="animate-pulse bg-slate-100 h-12 w-full mb-2"></div>
            <div class="animate-pulse bg-slate-100 h-12 w-full mb-2"></div>
            <div class="animate-pulse bg-slate-100 h-12 w-full"></div>
         </div>
    </div>
</template>

<script>
export default {
    name: "LoadingPlaceholder",
    props: {
        loading: {
            type: Boolean,
            required: true,
        },
        stats: {
            type: Boolean,
            required: false,
        },
        charts: {
            type: Boolean,
            required: false,
        },
        table: {
            type: Boolean,
            required: false,
        },
        subheader: {
            type: Boolean,
            required: false,
        },
    },
};
</script>

<style scoped>
.loading-analytics-placeholder {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    animation: fade-in 0.5s ease-in-out;
}

@keyframes fade-in {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.animate-pulse {
    @apply bg-gray-50 rounded-md;
    animation: pulse 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
}
</style>
